import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router não rola até o elemento do hash ao navegar para `/#features`, etc.
 * Este componente sincroniza `location.hash` com scroll na home.
 */
export function HomeHashScroll() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") return;

    const id = location.hash?.replace(/^#/, "").trim();
    if (!id) return;

    const scrollToEl = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      }
      return false;
    };

    if (scrollToEl()) return;

    const t1 = window.setTimeout(scrollToEl, 0);
    const t2 = window.setTimeout(scrollToEl, 120);
    const t3 = window.setTimeout(scrollToEl, 350);

    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      window.clearTimeout(t3);
    };
  }, [location.pathname, location.hash]);

  return null;
}
